import './Pricing.css';

const PLAN = {
  name: 'VERDICT',
  category: 'Automated Hiring Platform',
  desc: 'AI based Hiring System',
  priceINR: '₹15,000',
  priceUSD: '$160',
  period: '/month',
  seats: '50',
  features: [
    'Full Admin & Candidate Portal access',
    'AI-powered resume parsing & fit-scoring',
    'Unlimited assessments & job postings',
    'Up to 50 recruiter/admin user seats',
    'Analytics dashboard & reporting',
    'Priority onboarding support',
  ],
};

export default function Pricing() {
  return (
    <section id="pricing" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">Pricing</span>
        <h2 className="sec-title">Simple, transparent pricing.</h2>
        <p className="sec-sub" style={{ marginBottom: '3rem' }}>
          One plan, everything included. Scale your hiring without worrying about hidden fees.
        </p>

        <div className="plan-card">
          <div className="plan-card__main">
            <div className="plan-card__head">
              <span className="plan-card__badge">Full Platform</span>
              <h3 className="plan-card__name">{PLAN.name}</h3>
              <p className="plan-card__category">{PLAN.category}</p>
              <p className="plan-card__desc">{PLAN.desc}</p>
            </div>

            <ul className="plan-card__features">
              {PLAN.features.map(f => (
                <li key={f}><span className="pf-check">✓</span> {f}</li>
              ))}
            </ul>
          </div>

          <div className="plan-card__aside">
            <div className="plan-card__prices">
              <div className="plan-price-row">
                <span className="plan-price">{PLAN.priceINR}</span>
                <span className="plan-price-period">{PLAN.period}</span>
              </div>
              <div className="plan-price-row plan-price-row--alt">
                <span className="plan-price plan-price--alt">{PLAN.priceUSD}</span>
                <span className="plan-price-period">{PLAN.period} USD</span>
              </div>
            </div>

            <div className="plan-card__seats">
              <span className="plan-seats-num">{PLAN.seats}</span>
              <span className="plan-seats-label">user seats included</span>
            </div>

            <a href="#contact" className="btn-purple plan-card__cta">Contact Us →</a>
            <p className="plan-card__note">Custom volumes &amp; enterprise SLAs available on request.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
